import modulesConfig from "./modules.config"

export const technology = {
    ...modulesConfig.TECHNOLOGY,
}

export const rtTechnology = {
    ...modulesConfig.RT_TECHNOLOGY,
}

export const speciality = {
    ...modulesConfig.SPECIALITY,
}

